import axiosHelper from '@/utils/axiosHelper'
import userInfoUtil from '@/utils/userInfoUtil'
import dateTimeUtil from '@/utils/dateTimeUtil'
import number from '@/components/sys/Number'
import { Loading } from 'element-ui'

export default {
  // 获取表格编辑器配置信息
  getTableEditorAndFieldInfo: async function (tableEditorCode) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.GetTableEditorAndFieldInfo', {
      tableEditorCode: tableEditorCode
    })
    if (rtnObj.error === '000000') {
      return {
        error: '000000',
        tableEditorInfo: rtnObj.tableEditorInfo[0],
        tableEditorFieldInfo: rtnObj.tableEditorFieldInfo
      }
    } else {
      return rtnObj
    }
  },

  // 表格编辑器显示方法
  showTableEditor: async function (that, tableEditorName) {
    const tableEditor = that[tableEditorName]
    if (tableEditor.tableEditorFieldInfo.length <= 0) {
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await this.getTableEditorAndFieldInfo(tableEditor.tableEditorCode)
      if (rtnObj.error === '000000') {
        tableEditor.tableEditorInfo = rtnObj.tableEditorInfo
        tableEditor.tableEditorFieldInfo = rtnObj.tableEditorFieldInfo
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
    this.tableEditorReset(that, tableEditorName)
  },

  // 表格编辑器数据重置方法
  tableEditorReset: async function (that, tableEditorName) {
    const tableEditor = that[tableEditorName]
    if (tableEditor.editFlag) {
      for (let i = 0; i < tableEditor.tableEditorFieldInfo.length; i++) {
        const oneField = tableEditor.tableEditorFieldInfo[i]
        if (oneField.EditDefaultValType === '0') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, tableEditor.oldTableEditorContent[oneField.FieldCode])
        } else if (oneField.EditDefaultValType === '1') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, dateTimeUtil.formartDateTime(new Date(), oneField.DateFormat))
        } else if (oneField.EditDefaultValType === '2') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, userInfoUtil.getUserCode())
        } else if (oneField.EditDefaultValType === '3') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, userInfoUtil.getUserName())
        } else if (oneField.EditDefaultValType === '4') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, oneField.EditDefaultVal)
        } else if (oneField.EditDefaultValType === '5') {
          const numberStr = await number.getNumber(oneField.EditDefaultVal)
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, numberStr)
        }
      }
      if (tableEditor.tableEditorInfo.CheckOutTimeFlag === '1') {
        that.$set(tableEditor.tableEditorContent, 'TimeStamp', tableEditor.oldTableEditorContent.TimeStamp)
      }
    } else {
      tableEditor.tableEditorFieldInfo.forEach(async oneField => {
        if (oneField.SaveDefaultValType === '0') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, '')
        } else if (oneField.SaveDefaultValType === '1') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, dateTimeUtil.formartDateTime(new Date(), oneField.DateFormat))
        } else if (oneField.SaveDefaultValType === '2') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, userInfoUtil.getUserCode())
        } else if (oneField.SaveDefaultValType === '3') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, userInfoUtil.getUserName())
        } else if (oneField.SaveDefaultValType === '4') {
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, oneField.SaveDefaultVal)
        } else if (oneField.SaveDefaultValType === '5') {
          const numberStr = await number.getNumber(oneField.SaveDefaultVal)
          that.$set(tableEditor.tableEditorContent, oneField.FieldCode, numberStr)
        }
      })
    }
  },

  // 表格编辑器数据新增保存方法
  saveTableEditor: async function (tableEditorInfo) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.SaveTableEditorContent', {
      tableEditorCode: tableEditorInfo.tableEditorCode,
      tableEditorContent: tableEditorInfo.tableEditorContent
    })
    return rtnObj
  },

  // 表格编辑器数据修改保存方法
  editTableEditor: async function (tableEditorInfo) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.EditTableEditorContent', {
      tableEditorCode: tableEditorInfo.tableEditorCode,
      tableEditorContent: tableEditorInfo.tableEditorContent
    })
    return rtnObj
  },

  // 表格编辑器数据保存方法
  saveOrEditTableEditor: async function (that, tableEditorName) {
    if (!this.fieldNotNullCheck(that, tableEditorName)) {
      return
    }
    const tableEditorInfo = that[tableEditorName]
    const loadingInstance = Loading.service({ fullscreen: true })
    let rtnObj
    if (tableEditorInfo.editFlag) {
      rtnObj = await this.editTableEditor(tableEditorInfo)
    } else {
      rtnObj = await this.saveTableEditor(tableEditorInfo)
    }
    loadingInstance.close()
    return rtnObj
  },

  // 表格编辑器字段为空检测方法
  fieldNotNullCheck: function (that, tableEditorName) {
    const tableEditorInfo = that[tableEditorName]
    const tableEditorFieldInfo = tableEditorInfo.tableEditorFieldInfo
    for (let i = 0; i < tableEditorFieldInfo.length; i++) {
      if (tableEditorInfo.editFlag && tableEditorFieldInfo[i].EditSave === '0') {
        continue
      }
      if (tableEditorFieldInfo[i].NotNull === '1') {
        if (!tableEditorInfo.tableEditorContent[tableEditorFieldInfo[i].FieldCode]) {
          that.$message.error('请输入' + tableEditorFieldInfo[i].FieldLabel)
          return false
        }
      }
    }
    return true
  },

  // 表格编辑器数据删除方法
  deleteTableEditor: async function (that, tableEditorName, tableEditorContents) {
    const tableEditorInfo = that[tableEditorName]
    const rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.DeleteTableEditorContent', {
      tableEditorCode: tableEditorInfo.tableEditorCode,
      tableEditorContents: tableEditorContents
    })
    return rtnObj
  },

  // 表格编辑器数据快速迁移SQL生成方法
  createTableEditorMoveSQL: async function (that, tableEditorName, selections) {
    const loadingInstance = Loading.service({ fullscreen: true })
    const tableEditorInfo = that[tableEditorName]
    const rtnObj = await axiosHelper.handle('/WebSYSAction/TableEditor.GetTableEditorMoveSQL', {
      tableEditorCode: tableEditorInfo.tableEditorCode,
      selections: selections
    })
    if (rtnObj.error === '000000') {
      let consoleStr = ''
      for (let i = 0; i < rtnObj.sqlList.length; i++) {
        consoleStr += rtnObj.sqlList[i]
      }
      console.log(consoleStr)
      that.$message.success('恭喜你，导出成功，请到控制台查看！')
    } else {
      that.$message.error(rtnObj.msg)
    }
    loadingInstance.close()
  }
}
